import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import { SectionHeading } from "components/misc/Headings";

const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-gray-900`;
const Text = styled.div`
  ${tw`text-lg text-gray-800`}
  p {
    ${tw`mt-2 leading-loose`}
  }
  h2 {
    ${tw`text-2xl font-bold mt-8 mb-4`}
  }
  h3 {
    ${tw`text-xl font-bold mt-6 mb-3`}
  }
  h4 {
    ${tw`text-lg font-bold mt-4 mb-2`}
  }
  ol {
    ${tw`list-decimal list-inside mt-3 mb-6 ml-4`}
    li {
      ${tw`mb-2`}
    }
  }
  ul {
    ${tw`list-disc list-inside mt-3 mb-4 ml-4`}
    li {
      ${tw`mb-2`}
    }
  }
`;

export default ({
  headingText = "Termos de Uso e de Propriedade Intelectual",
}) => {
  return (
    <AnimationRevealPage>
      <Header />
      <Container>
        <ContentWithPaddingXl>
          <HeadingRow>
            <Heading>{headingText}</Heading>
          </HeadingRow>
          <Text>
            <p>
              Os presentes Termos de Uso e de Propriedade Intelectual da
              'TRATAZ–Tratamentos Digitalizados de A a Z" demonstram o modo como
              a TRATAZ funciona, conduz seus negócios, e como as leis são
              aplicáveis aos seus serviços. Assim, estes termos ajudam a definir
              a relação do usuário com a TRATAZ, por meio das seguintes seções:
            </p>

            <ol>
              <li>
                O que esperar da TRATAZ, descrevendo o modo como fornece e
                desenvolve os serviços.
              </li>
              <li>
                O que esperar do usuário da TRATAZ, estabelecendo-se as regras
                para utilização dos serviços ofertados.
              </li>
              <li>
                Conteúdo a ser incluído na plataforma/site, definindo os
                direitos de propriedade intelectual com relação ao conteúdo que
                pode ser encontrado, seja ele pertencente ao usuário, à TRATAZ
                ou a terceiros.
              </li>
              <li>
                Caso o usuário não concorde ou venha a ter problemas no uso, a
                compreensão destes termos é imprescindível, haja vista que, para
                usar os serviços da TRATAZ, o usuário necessita aceitá-los.
              </li>
            </ol>

            <p>
              Além destes termos, também possuímos uma Política de Privacidade,
              que recomendamos que seja lida integralmente pelo usuário, para
              que compreenda a melhor forma de atualizar, gerenciar e excluir
              seus dados pessoais, de acordo com a Lei nº 13.709/18 (Lei Geral
              de Proteção de Dados – LGPD).
            </p>

            <h2>1. O que esperar da TRATAZ</h2>
            <p>
              Os serviços da TRATAZ que você pode contratar são fornecidos no
              sítio eletrônico:{" "}
              <a
                href="https://trataz.com"
                className="text-primary-500 hover:underline"
              >
                https://trataz.com
              </a>
              . TRATAZ – Tratamentos Digitalizados de A a Z organizada e operada
              de acordo com as leis brasileiras
              <br />
              Rua Tenente Paulo Lopes, 309
              <br />
              Sala 301, Boa Vista, Joinville/SC
              <br />
              Brasil
            </p>

            <h3>Restrições de idade</h3>
            <p>
              Se você possui idade inferior à exigida para gerenciar sua própria
              conta, é necessário ter a permissão do seu pai/mãe ou responsável
              legal para usar uma conta. Peça para seu pai/mãe ou responsável
              legal ler estes termos juntamente com você.
            </p>
            <p>
              Se você é pai/mãe ou responsável legal e permite que uma
              criança/adolescente use os serviços, estes termos se aplicam a
              você, sendo você também responsável pelas atividades desta
              criança/adolescente nos serviços.
            </p>

            <h3>Fornecimento de serviços</h3>
            <p>
              A TRATAZ fornece serviços que estão sujeitos aos presentes termos,
              exclusivamente no sítio eletrônico{" "}
              <a
                href="https://trataz.com"
                className="text-primary-500 hover:underline"
              >
                https://trataz.com
              </a>
              . Fazem parte deste serviço também os conteúdos que podem ser
              incluídos por terceiros, vistos e baixados pelo usuário, e com o
              qual se pode interagir.
            </p>

            <h3>Desenvolvimento e atualizações dos serviços</h3>
            <p>
              A TRATAZ desenvolve constantemente recursos/tecnologias para
              melhorar os seus serviços. Desta feita, se houver mudanças que
              impactem seu uso dos nossos serviços ou se pararmos de oferecer
              algum serviço, enviaremos um aviso com antecedência, salvo em
              situações urgentes, por exemplo: para evitar abuso de direito,
              cumprir com obrigações legais ou resolver problemas técnicos ou de
              segurança da informação.
            </p>

            <h2>2. O que esperar do usuário da TRATAZ</h2>
            <p>
              O cumprimento da legislação, destes termos e dos documentos
              adicionais específicos do serviço. A permissão que concedemos a
              você para usar nossos serviços permanecerá enquanto cumprir:
            </p>
            <ul>
              <li>a estes termos;</li>
              <li>
                aos demais documentos adicionais específicos do serviço, o que
                pode, por exemplo, incluir restrições mais rígidas.
              </li>
            </ul>
            <p>
              Também disponibilizamos nossa Política de Privacidade, que pode
              ser acessada pelo nosso site, no link .............. (assim que
              tiver criada)
            </p>
            <p>
              Embora tenhamos concedido a permissão temporária para que utilize
              os nossos serviços, a TRATAZ declara que mantém todos os direitos
              de propriedade intelectual que detemos sobre eles, e fica aqui o
              usuário expressamente cientificado.
            </p>

            <h2>3. Conteúdo a ser incluído na TRATAZ</h2>
            <h3>Seu conteúdo</h3>
            <p>
              Parte dos serviços da TRATAZ consiste na permissão para que uma
              clínica ou profissional liberal (odontologia, fonoaudiologia,
              etc.) ou cliente em geral disponibilize seu conteúdo publicamente
              no site da TRATAZ. Por exemplo, é possível postar uma um
              tratamento ou exercício ou ainda fazer upload de uma postagem em
              uma página que um terceiro criou.
            </p>
            <p>
              Se acredita que alguém está violando seus direitos de propriedade
              intelectual ou direitos de terceiros, pode nos enviar um aviso
              sobre a violação para tomarmos as providências necessárias. Por
              exemplo, podemos suspender ou encerrar as Contas de violadores de
              direitos autorais reincidentes.
            </p>

            <h3>Conteúdo da TRATAZ</h3>
            <p>
              Alguns dos nossos serviços incluem conteúdo que pertence à TRATAZ.
              Você pode usar esse conteúdo de acordo com o permitido nestes
              termos, mas nós retemos todos os direitos de propriedade
              intelectual relacionados ao nosso conteúdo. Não remova, oculte ou
              mude nenhum dos nossos logotipos, marcas ou avisos legais. Se você
              quiser usar nossos logotipos ou marcas, consulte a proprietária da
              startup TRATAZ no e-mail:{" "}
              <a
                href="mailto:contato@trataz.com"
                className="text-primary-500 hover:underline"
              >
                contato@trataz.com
              </a>
            </p>

            <h3>Outros conteúdos</h3>
            <p>
              Alguns dos nossos serviços dão a você acesso a conteúdo que pode
              pertencer a outras pessoas ou organizações. Não use este conteúdo
              sem a permissão desta pessoa ou organização, ou de alguma forma
              que não seja permitida por lei. As opiniões expressas no conteúdo
              de outras pessoas ou organizações não refletem necessariamente as
              opiniões da TRATAZ.
            </p>

            <h2>4. Não concordância com os termos e Resolução de Problemas</h2>
            <p>
              A legislação brasileira e estes termos concedem a você o direito a
              possibilidades de resolver problemas se algo der errado.
            </p>

            <h3>Responsabilidades</h3>
            <h4>Para todos os usuários</h4>
            <p>
              Tanto a legislação quanto estes termos buscam alcançar um
              equilíbrio quanto ao que o usuário e a TRATAZ podem reivindicar em
              caso de problemas. A TRATAZ será responsável apenas pelas próprias
              violações destes termos ou dos termos adicionais específicos do
              serviço, sujeitas à legislação aplicável.
            </p>

            <h4>Somente para usuários comerciais e organizações</h4>
            <p>Se você é um usuário comercial ou uma organização:</p>
            <ul>
              <li>
                na medida permitida por lei, você indenizará a TRATAZ e os
                diretores, executivos, funcionários e prestadores de serviço
                dele por quaisquer ações judiciais de terceiros decorrentes ou
                relacionadas ao uso ilegal dos serviços, a violações destes
                termos ou dos termos adicionais específicos do serviço. Essa
                indenização cobre qualquer responsabilidade ou despesa
                decorrente de ações judiciais, perdas, danos, julgamentos,
                multas, custos de litígios e honorários advocatícios.
              </li>
            </ul>

            <p>
              A TRATAZ não será responsável pelas seguintes responsabilidades:
            </p>
            <ul>
              <li>
                Perda de lucros, receitas, oportunidades de negócios, clientela
                ou economias previstas;
              </li>
              <li>Perda indireta ou emergente;</li>
              <li>Danos punitivos.</li>
            </ul>

            <h3>Tomando providências em caso de problemas</h3>
            <p>
              Antes de tomar as providências descritas abaixo, forneceremos um
              aviso prévio sempre que possível, descreveremos o motivo da nossa
              ação e daremos a você a oportunidade de resolver o problema, a
              menos que haja motivos razoáveis para acreditar que fazer isso:
            </p>
            <ul>
              <li>
                causaria dano ou responsabilidade para um usuário, terceiros ou
                à TRATAZ;
              </li>
              <li>
                violaria a legislação ou determinação de autoridade pública;
              </li>
              <li>comprometeria uma investigação;</li>
              <li>
                comprometeria a operação, integridade ou segurança dos nossos
                serviços.
              </li>
            </ul>

            <h3>Remover seu conteúdo</h3>
            <p>
              Se tivermos razões concretas para acreditar que qualquer conteúdo
              seu viola estes termos, os documentos adicionais específicos do
              serviço ou as políticas; viola a legislação aplicável; ou pode
              prejudicar nossos usuários, terceiros ou a TRATAZ, reservamo-nos o
              direito de retirar parte ou a totalidade desse conteúdo de acordo
              com a legislação aplicável. Exemplos: pornografia infantil,
              facilitação de assédio ou tráfico de pessoas, conteúdo terrorista,
              conteúdo que viole os direitos humanos, conteúdo que viole
              propriedade intelectual de outra pessoa, etc.
            </p>

            <h3>
              Suspender ou encerrar acesso do usuário aos serviços da TRATAZ
            </h3>
            <p>
              A TRATAZ se reserva o direito de suspender ou encerrar o acesso do
              usuário aos serviços ou excluir a conta, se alguma destas
              situações acontecer:
            </p>
            <ul>
              <li>
                O usuário violar estes termos, os documentos adicionais
                específicos do serviço ou as políticas de forma relevante ou
                recorrente.
              </li>
              <li>
                Se precisarmos fazer isso para obedecer a uma obrigação legal ou
                ordem judicial.
              </li>
              <li>
                Se tivermos motivos relevantes para crer que a conduta do
                usuário causa danos ou responsabilidade a outro usuário, a
                terceiros ou à TRATAZ, por exemplo, por meio de hacking,
                phishing, assédio, prática de spam, enganação de outras pessoas
                ou cópia de conteúdo que não pertença ao usuário.
              </li>
            </ul>

            <p>
              O usuário pode parar de usar os serviços da TRATAZ a qualquer
              momento. Se o usuário optar por parar de utilizar os serviços,
              pedimos a gentileza, se possível, de informar o motivo, para que o
              serviço possa melhorar.
            </p>

            <h2>5. Propriedade Intelectual</h2>
            <p>
              Direitos de propriedade intelectual (direitos de PI). Direitos
              sobre as criações intelectuais individuais, como invenções
              (direitos de patente); obras literárias e artísticas (direitos
              autorais); designs (direitos de design); e símbolos, nomes e
              imagens usados no comércio (marcas registradas).
            </p>
            <p>
              Os direitos de propriedade intelectual dos presentes termos,
              exceto quando o conteúdo for publicado por terceiros, pertencem à
              TRATAZ.
            </p>

            <h3>Soluções de disputas, legislação aplicável e tribunais</h3>
            <p>
              Para obter informações sobre como entrar em contato com a TRATAZ:{" "}
              <a
                href="mailto:contato@trataz.com"
                className="text-primary-500 hover:underline"
              >
                contato@trataz.com
              </a>
            </p>
            <p>
              As leis brasileiras vão reger todas as disputas que surgirem com
              relação a estes termos ou qualquer serviço relacionado. Essas
              disputas serão resolvidas exclusivamente no Foro de Joinville/SC,
              e o usuário e a TRATAZ concordam com esta jurisdição.
            </p>
          </Text>
        </ContentWithPaddingXl>
      </Container>
      <Footer />
    </AnimationRevealPage>
  );
};
